//import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import DoneAllIcon from '@mui/icons-material/DoneAll'
import { Text } from '../../../../../ui'
import { bankIcons } from '../data'
import imgDefaultBank from '../../../../../../../assets/iconos/iconCasa.png'
import clsx from 'clsx';
import { formatCurrency, formatDate } from '../../../../../../utils/formatter'
import { useEffect, useMemo, useRef, useState } from 'react'
import SearchIcon from '@mui/icons-material/Search'
import translations from '../../../../../ui/traslation/traslationAdministracion.json'
import { getMovementRelationDate } from './respaldo.utils'

const TablaTraspasoCuenta = ({onCheckboxChange,rows,dataLinkage,onSort,order,onInitialSelectedIds,onCurrentSelectedIdsChange,rowsPerPage,
  dataModal,onCurrentData,selectedCheckboxes,setSelectedCheckboxes,onCurrentRealIdsChange,excludeCurrentBank = true,
  selectReconciledByDefault = true,enablePagination = false,hasMore = false,isLoadingMore = false,
  onLoadMore,totalCount}) => {
  const [tablePage, setTablePage] = useState(0)
  const lastSelectionRef = useRef(null)
  const pageSize = 50
  
  useEffect(() => {
    if (!Array.isArray(rows)) return
  
    const selectedRows = Object.entries(selectedCheckboxes)
      .filter(([_, isChecked]) => isChecked)
      .map(([key]) => rows.find(r => r?.id === Number(key)))
      .filter(Boolean)
  
    const selectedIds = selectedRows.map(r => r.id)
    const selectedRealIds = selectedRows.map(r => r.idPrincipal ?? r.id)

    // El padre puede recrear las filas sin cambiar su contenido. No volver a
    // notificar la misma selección: actualizaría al padre indefinidamente.
    const selectionKey = JSON.stringify(selectedRows)
    if (lastSelectionRef.current === selectionKey) return
    lastSelectionRef.current = selectionKey
  
    onCurrentSelectedIdsChange?.(selectedIds)
    onCurrentRealIdsChange?.(selectedRealIds)
    onCurrentData?.(selectedRows)
  }, [selectedCheckboxes, rows])

  useEffect(() => {
  if (!Array.isArray(rows) || rows.length === 0) return

    const initial = {}
    rows.forEach(item => {
    initial[item.id] = Boolean(
      item.seleccionado ||
      (selectReconciledByDefault && item.status === "CONCILIADO")
    )
  })
  setSelectedCheckboxes(prev => {
    const missingIds = Object.keys(initial).filter(id => !Object.prototype.hasOwnProperty.call(prev, id))
    if (missingIds.length === 0) return prev
    return { ...initial, ...prev }
  })
}, [rows, dataLinkage, selectReconciledByDefault, setSelectedCheckboxes])


  const styles = {
    wrapper: 'overflow-x-auto rounded-3xl shadow-sm',
    table: 'w-full table-auto text-[0.725rem] border-collapse leading-tight',
    thead: 'sticky top-0 z-10 bg-gray-50',
    th: 'py-2 px-1 w-auto max-w-[120px] text-center break-words border-b border-gray-200 uppercase text-[0.6rem] font-bold text-gray-500',
    tr: 'border-b border-gray-100 hover:bg-gray-50 transition-colors',
    td: 'py-2 px-2 w-auto max-w-[200px] text-center break-words align-middle',
    smallCol: 'w-auto max-w-[80px]',
    wideCol: 'w-auto max-w-[300px]',
    boldText: 'font-bold text-[0.65rem]',
    text: 'text-[0.705rem] text-gray-400 font-medium',
  }


  const orderableCols = [
    { col: '', field: null },
    { col: 'Fecha', field: 'fecha' },
    { col: 'Cuenta Corriente', field: 'nombreCuentaBanco' },
    {col: 'Descripción', field: 'descripcion'},
    { col: 'Abono', field: 'montoAbono' },
    { col: 'Cargo', field: 'montoCargo' },
    { col: 'Disponible', field: 'disponible' },
    //{ col: 'Status', field: 'status' },
    { col: 'Acciones', field: 'aprobado' }
  ]

  const handleCheckboxToggle = id => {
    setSelectedCheckboxes(prev => ({
      ...prev,
      [id]: !prev[id],
    }))
  }

  const normalize = s => s?.toString().trim().toLowerCase()

  const filteredRows = useMemo(() => {
    if (!Array.isArray(rows)) return []
    if (!excludeCurrentBank) return rows

    const modalBanco = normalize(dataModal?.nombreBanco)
    return rows.filter(row => {
      const rowBanco = normalize(row?.nombreCuentaBanco)
      return (
        rowBanco &&
        rowBanco !== 'null' &&
        rowBanco !== modalBanco
      )
    })
  }, [rows, dataModal?.nombreBanco, excludeCurrentBank])

  useEffect(() => {
    setTablePage(0)
  }, [dataModal?.id, dataModal?.idPrincipal])

  const visibleRows = enablePagination
    ? filteredRows.slice(tablePage * pageSize, (tablePage + 1) * pageSize)
    : filteredRows

  const totalPages = Math.max(1, Math.ceil(filteredRows.length / pageSize))

  const handleNextPage = async () => {
    const nextPage = tablePage + 1
    const needsMoreRows = (nextPage + 1) * pageSize > filteredRows.length
    if (needsMoreRows && hasMore && onLoadMore) await onLoadMore()
    setTablePage(nextPage)
  }

//   const getCleanStatus = row =>
//       typeof row?.status === 'string'
//         ? row.status.replace(/\s*undefined\s*/gi, '').trim()
//         : ''
//
//   const normalizeStatus = status =>
//       String(status || '')
//         .replace(/\s*undefined\s*/gi, '')
//         .trim()
//         .toUpperCase()
//
//   const getDisplayStatus = (rowStatus, isChecked) => {
//     const normalizedRowStatus = normalizeStatus(rowStatus)
//     if (normalizedRowStatus && normalizedRowStatus !== '-') return normalizedRowStatus
//     if (!isChecked) return ''
//     const modalStatus = normalizeStatus(dataModal?.status)
//     if (modalStatus.includes('PARCIALMENTE COBRADO')) return 'PARCIALMENTE COBRADO'
//     if (modalStatus.includes('PARCIALMENTE PAGADO')) return 'PARCIALMENTE PAGADO'
//     if (modalStatus.includes('PARCIALMENTE CONCILIADO')) return 'PARCIALMENTE CONCILIADO'
//     if (modalStatus.includes('COBRADO')) return 'COBRADO'
//     if (modalStatus.includes('PAGADO')) return 'PAGADO'
//     if (modalStatus.includes('CONCILIADO')) return 'CONCILIADO'
//     return ''
//   }
//
//     const statusTone = status => {
//       const s = normalizeStatus(status)
//       if (s.includes('PARCIAL')) return 'warning'
//       if (s.includes('CONCILIADO') || s.includes('PAGADO') || s.includes('COBRADO')) return 'success'
//       if (s.includes('PENDIENTE')) return 'danger'
//       if (s.includes('PARCIAL') && s.includes('ANUL')) return 'muted'
//       return 'muted'
//     }
//
//     const statusBadgeClass = status => {
//       const tone = statusTone(status)
//       return clsx(
//         'inline-flex items-center justify-center px-3 py-1 rounded-full text-[0.6rem] sm:text-[0.65rem] font-semibold uppercase tracking-wider',
//         {
//           'text-danger bg-danger/10': tone === 'danger',
//           'text-success bg-success/10': tone === 'success',
//           'text-amber-700 bg-amber-100': tone === 'warning',
//           'text-muted bg-border/40': tone === 'muted'
//         }
//       )
//     }
//
  if (!filteredRows?.[0])
    return (
      <div className="flex flex-col items-center py-12">
        <SearchIcon fontSize="large" className="mb-4 text-gray-400" />
        <Text>{translations.tableAction.noData}</Text>
      </div>
    )
  else

  return (
    <div className={styles.wrapper}>
      <div className='max-h-[600px] mt-2'>
        <table className={styles.table}>
          <thead className={styles.thead}>
          <tr>
            {orderableCols.map(({ col, field }, i) => (
              <th key={i} className={styles.th}>
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
       {(visibleRows ?? []).map((row, i) => {
        const isChecked = !!selectedCheckboxes[row.id]
//         const cleanStatus = getCleanStatus(row)
//         const displayStatus = getDisplayStatus(cleanStatus, isChecked)
        return (
                <tr key={row.id ?? i} className={clsx(styles.tr)}>
              <td className={clsx(styles.td, styles.smallCol)}>
                <div className="flex items-center gap-2">
                  <input
                    type='checkbox'
                    className='rounded'
                    checked={isChecked}
                    onChange={() => handleCheckboxToggle(row.id)}
                  />
                  <img
                    src={bankIcons[row.nombreCuentaBanco] || imgDefaultBank}
                    className="min-w-8 h-8"
                  />
                </div>
              </td>
              <td className={clsx(styles.td, styles.mediumCol)}>
                <Text className={styles.boldText}>
                  {formatDate(getMovementRelationDate(row, dataLinkage ?? dataModal?.linkage ?? []))}
                </Text>
              </td>

              {/* Cuenta Corriente */}
              <td className={clsx(styles.td, styles.mediumCol)}>
                {row.nombreCuentaBanco === 'Caja Principal' ? (
                  <Text className={styles.boldText}>{row.nombreCuentaBanco}</Text>
                ) : (
                  <>
                    <Text className={styles.boldText}>{row.nombreCuentaBanco}</Text>
                    <Text className={styles.text}>{row.numeroCuentaBanco}</Text>
                  </>
                )}
              </td>

              {/* Descripción */}
              <td className={clsx(styles.td, styles.wideCol)}>
                <Text className={styles.boldText}>
                  {row.descripcion || '<descripcion>'}
                </Text>
              </td>

              {/* Abono */}
              <td className={clsx(styles.td, styles.mediumCol)}>
                <Text className={clsx(styles.boldText, 'font-bold')}>
                  {formatCurrency(row.montoAbono)}
                </Text>
              </td>

              {/* Cargo */}
              <td className={clsx(styles.td, styles.mediumCol)}>
                <Text className={clsx(styles.boldText, 'font-bold')}>
                  {formatCurrency(row.montoCargo)}
                </Text>
              </td>

              {/* DISPONIBLE */}
              <td className={clsx(styles.td, styles.mediumCol)}>
                <Text className={clsx(styles.boldText, 'font-bold')}>
                  {formatCurrency(row.auxiliar)}
                </Text>
              </td>

              {/* Status 
              <td className={clsx(styles.td, styles.mediumCol)}>
                <span className={statusBadgeClass(displayStatus)}>
                {displayStatus || '—'}
              </span>
              </td>*/}
              <td className={clsx(styles.td, styles.mediumCol)}>
                <div className='flex h-full items-center justify-center space-x-3'>
                  <div className='flex flex-col text-xs text-gray-500 items-center justify-center hover:cursor-pointer'>
                    <button
                      className={clsx(
                        'flex items-center justify-center w-7 h-7 rounded-full shadow-full-xs transition-colors duration-150',
                        {
                          'bg-accent2 text-white hover:bg-accent2/90 cursor-pointer': isChecked,
                          'bg-gray-100 text-gray-300 hover:bg-gray-200 cursor-pointer':
                            !isChecked
                        }
                      )}
                      onClick={() => handleCheckboxToggle(row.id)}
                    >
                      <DoneAllIcon className='w-4 h-4' />
                    </button>
                    <Text className='mt-2'>{isChecked ? 'Seleccionado' : 'Seleccionar'}</Text>
                  </div>
                </div>
              </td>
            </tr>
           )
          })}
        </tbody>
        </table>
        {enablePagination && (filteredRows.length > pageSize || hasMore) && (
          <div className='flex items-center justify-between border-t border-gray-100 px-3 py-2'>
            <span className='text-xs text-gray-500'>
              {tablePage * pageSize + 1} - {Math.min((tablePage + 1) * pageSize, filteredRows.length)} de {totalCount ?? filteredRows.length}
            </span>
            <div className='flex gap-2'>
              <button
                type='button'
                className='rounded-full border border-gray-300 px-3 py-1 text-xs disabled:cursor-not-allowed disabled:opacity-40'
                disabled={tablePage === 0}
                onClick={() => setTablePage(page => Math.max(0, page - 1))}
              >
                Anterior
              </button>
              <button
                type='button'
                className='rounded-full border border-gray-300 px-3 py-1 text-xs disabled:cursor-not-allowed disabled:opacity-40'
                disabled={isLoadingMore || (tablePage >= totalPages - 1 && !hasMore)}
                onClick={handleNextPage}
              >
                {isLoadingMore ? 'Cargando...' : 'Siguiente'}
              </button>
            </div>
          </div>
        )}
    </div>
    </div>
  );
};

export default TablaTraspasoCuenta
